// Header/footer content of jobnet.ag, shared by jnjts (talentspace.jobnet.ag), jnjtsat
// (talentspace.jobnet.at) and jnjtseu (talentpool.eu). The main site is German only.
// The menu itself is the shared jobnet.ag navigation in src/config/navigation.ts.

import { getByDomain } from '@/config/sites';
import type { SiteTalentspaceContent } from '../types';

export const JOBNETAG_SITE = 'https://www.jobnet.ag';

// The logo: jnjtsat links to jobnet.at, the others to jobnet.ag (the `site` of the domain config)
export const jobnetagSite = (): string => {
  const theme = getByDomain();
  if (theme && theme.site) {
    return theme.site;
  }
  return JOBNETAG_SITE;
};

export const jobnetagTopLinks = (site: string) => [
  { text: 'Standorte', href: `${site}/JobnetAG/Standorte/` },
  { text: 'Newsletter', href: `${site}/JobnetAG/Newsletter/` },
  { text: 'Karriere', href: `${site}/JobnetAG/Karriere/` },
  { text: 'Kontakt', href: `${site}/JobnetAG/Kontakt/` },
  { text: 'Support/Webinare', href: `${site}/JobnetAG/Kontakt/Support-Webinare.php` },
];

export const JOBNETAG_LINKEDIN_URL = 'https://www.linkedin.com/company/jobnet-ag-digital-employment-solutions/';

// The jobnet.ag footer newsletter form posts straight to CleverReach
export const JOBNETAG_NEWSLETTER_ACTION = 'https://eu1.cleverreach.com/f/64494-129403/wcs/';

export const JOBNETAG_IMPRINT_URL = `${JOBNETAG_SITE}/JobnetAG/Kontakt/impressum.php`;

export const JOBNETAG_PRIVACY_URL = `${JOBNETAG_SITE}/JobnetAG/datenschutz.php`;

export const JOBNETAG_SHORT_URL = `${JOBNETAG_SITE}/1676`;

// Talentspace content of the jobnet.ag brand: the partner card's "Partnerschaft anfragen" e-mail
export const jobnetagTalentspace: SiteTalentspaceContent = {
  partnerEmail: 'ac@jobnet.solutions',
};
